import { Copy } from '../copy/Copy';
import { Cycle } from '../icons/Cycle/Cycle';
import { Other } from '../icons/Other/Other';
import { Run } from '../icons/Run/Run';
import { Swim } from '../icons/Swim/Swim';
import { Walk } from '../icons/Walk/Walk';
import { approxCalorieCounter } from './approxCalorieCounter';

export const totalsMapper = (userData) => [
  {
    distance: userData.totalWalking,
    activity: Copy.generate('Global.walking'),
    icon: <Walk />,
    calories: approxCalorieCounter('W', userData.totalWalking),
  },
  {
    distance: userData.totalRunning,
    activity: Copy.generate('Global.running'),
    icon: <Run />,
    calories: approxCalorieCounter('R', userData.totalRunning),
  },
  {
    distance: userData.totalCycling,
    activity: Copy.generate('Global.cycling'),
    icon: <Cycle />,
    calories: approxCalorieCounter('C', userData.totalCycling),
  },
  {
    distance: userData.totalSwimming,
    activity: Copy.generate('Global.swimming'),
    icon: <Swim />,
    calories: approxCalorieCounter('S', userData.totalSwimming),
  },
  {
    distance: userData.totalOther,
    activity: Copy.generate('Global.other'),
    icon: <Other />,
    calories: approxCalorieCounter('O', userData.totalOther),
  },
];
